import {IngestionMessage, MessageScope} from "../asset-service-api";
import {useProjects} from "../Behaviors/projects";
import { useApp } from "../Behaviors/app";
import { useStore } from "../State/zustandStore";
import { ProjectType } from "../api";

export const useSdHdValidator = (projId?: string | undefined) => {
    const workspaceState = useStore().projects;
    const projectId = workspaceState.selectedProjectId ?? projId;
    const {project, getMappedTrack, getMappedResources} = useProjects(projectId!);
    const app = useApp();
    const isProductSdHd = () => {
        switch (project?.releaseInfo?.configuration) {
        case "eAlbum Audio":
        case "eSingle Audio":
        case "eSingle Audio(Sollos)":
        case "eAlbum Audio(Sollos)":
        case "eAudio Stem Bundle":
        case "eMix Bundle Album":
        case "eMix Bundle Single":
            return true;
        default:
            return false;
        }
    };
    const mappedResource = getMappedResources(project!);
    const getMessage = (enableHdForSd: boolean) => {
        if (project?.projectType === ProjectType.Release) {
            return `Tracks on SD products must be ${enableHdForSd ? "16, 24, or 32" : "16"} bit.`;
        }
        else if (project?.projectType !== ProjectType.Resource) {
            return `Asset assigned to audio resource must be ${enableHdForSd ? "16, 24, or 32" : "16"} bit.`;
        } //We are allowing assets with all bit depth for WAV-ISRCs/Resource projects
    };

    const getScope = () => {
        return project?.projectType === ProjectType.Resource ? MessageScope.Resource : MessageScope.Track;
    };

    const getSDHDValidationErrors = (): IngestionMessage[] => {
        const {enableHdForSd} = app.features;
        const allowedBitDepths = enableHdForSd ? [16, 24, 32] : [16];
        const allowedChannels = 2;

        if (isProductSdHd() && project?.projectType !== ProjectType.Resource) {
            const errorMessages = mappedResource.filter(x => !allowedBitDepths.includes(x.audioInfo?.bit_depth ?? 0)).map(x => {
                return {
                    details: `Asset ${ x.filename }, assigned to Track ${ getMappedTrack(project!, x)?.number }, Bit Depth (${ x.audioInfo?.bit_depth }) must be (${enableHdForSd ? "16, 24, or 32" : "16"}) for configuration ${project?.releaseInfo?.configuration}`,
                    message: getMessage(enableHdForSd),
                    messageType: "Error",
                    source: {
                        id: "E778BFD9-6D39-49C9-9AED-4CFC954752FB",
                        scope: getScope(),
                        stage: "local",
                        target: getMappedTrack(project!, x)?.number.toString(),
                    },
                } as IngestionMessage;
            });

            errorMessages.push(...mappedResource.filter(x => (x.audioInfo?.channels ?? 0) !== allowedChannels).map(x => {
                return {
                    message: `File has ${x.audioInfo?.channels ?? 0} audio channels. This product configuration requires ${allowedChannels} channels.`,
                    messageType: "Error",
                    source: {
                        scope: getScope(),
                        stage: "local",
                        target: getMappedTrack(project!, x)?.number.toString(),
                        id: "C9D91176-5F73-4B94-9F9C-7C04F83733F1",
                    },
                } as IngestionMessage;
            }));
            return errorMessages;
        } else return [];
    };
    return { getSDHDValidationErrors, isProductSdHd};
};
